<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="storm-clouds">
<p style="margin-top: 250px; text-align: center;">“I am not going to lose Vietnam. I am not going to be the president who saw Southeast Asia go the way China went.”</p><br/>
<p style="text-align: right;">President Lyndon Johnson</p>
<p style="text-align: right;">To Ambassador Henry Cabot Lodge</p>
<p style="text-align: right;">November 24, 1963</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0010.vue?0da5636f